<app-dashboard-container
	class="dashboard-plaatsing-advies"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentExpressions(), $event)"
>
	<app-filter-panel
		[defaultFilters]="initialFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/doorstroom"
		[permanentFilterExpressions]="permanentExpressions()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<div class="cl-header-subtitle">
				<span>{{ getSchooljarenCaption() }}</span>
				<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="getSchooljarenTooltip()"></app-icon>
			</div>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-schooljaar-indicator-over [hideExclusief]="DRIE_SCHOOLJAREN_EXCL_2020"></app-schooljaar-indicator-over>
			<app-onderwijsresultaten-uitsluiten-filter></app-onderwijsresultaten-uitsluiten-filter>
			<app-legenda class="cl-header-utility" [attribute]="['x_onderwijspositie_punten']"></app-legenda>
		</app-dashboard-header>
		<app-barchart-table
			[filters]="filterExpressions()"
			[permanentFilters]="permanentExpressions()"
			[groups]="groups()"
			[subgroups]="subgroups()"
			[config]="this"
		></app-barchart-table>
	</section>
</app-dashboard-container>
